/* eslint-disable */

// This file was automatically generated by @icp-sdk/bindgen@0.4.1.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import type { ActorMethod } from '@icp-sdk/core/agent';
import type { Principal } from '@icp-sdk/core/principal';
import { IDL } from '@icp-sdk/core/candid';

export interface Account {
  'owner' : Principal,
  'subaccount' : [] | [Uint8Array],
}
export interface Activity {
  /**
   * Different people who posted or replied in the whole range.
   */
  'posters' : number,
  'notifications' : bigint,
  'trades' : bigint,
  'all_posts' : bigint,
  'follows' : bigint,
  /**
   * Hourly for a one-day range, daily otherwise; oldest first.
   */
  'bucket_secs' : bigint,
  /**
   * The tokens with the most posts and replies in the range.
   */
  'top_tokens' : Array<[Principal, number]>,
  'buckets' : Array<Bucket>,
}
export interface AuthorStats {
  'tokens' : number,
  'posts' : bigint,
  'first_at' : [] | [bigint],
}
export interface Bucket {
  /**
   * Different people who posted or replied.
   */
  'posters' : number,
  'moments' : number,
  /**
   * Start of the bucket, in seconds since 1970.
   */
  'start' : bigint,
  'replies' : number,
  'posts' : number,
  /**
   * Reactions on the posts made in this bucket (counted when read, so they keep growing).
   */
  'reactions' : number,
}
export interface Followed {
  'people' : Array<Principal>,
  'tokens' : Array<Principal>,
}
export interface HttpRequest {
  'url' : string,
  'method' : string,
  'body' : Uint8Array,
  'headers' : Array<[string, string]>,
}
export interface HttpResponse {
  'body' : Uint8Array,
  'headers' : Array<[string, string]>,
  'upgrade' : [] | [boolean],
  'status_code' : number,
}
export interface Init { 'factory' : Principal }
export interface NewPost {
  /**
   * Posted by an agent (shown as a label, for transparency).
   */
  'agent' : [] | [boolean],
  'text' : string,
  'market' : Principal,
  /**
   * Reply to this top-level post (replies are one level deep).
   */
  'parent' : [] | [bigint],
}
export interface Notif {
  'at' : bigint,
  'id' : bigint,
  'actor' : [] | [Principal],
  /**
   * "reply", "mention", "reaction", "listed", "milestone", "launch" (someone you follow).
   */
  'kind' : string,
  'post' : [] | [bigint],
  'market' : [] | [Principal],
}
export interface PostView {
  'at' : bigint,
  'id' : bigint,
  'deleted' : boolean,
  'imported' : boolean,
  'subject' : [] | [Principal],
  /**
   * The caller's own reactions, as bits.
   */
  'mine' : number,
  'badges' : number,
  'hidden' : boolean,
  'text' : string,
  'author' : Principal,
  /**
   * The token creator's pinned update.
   */
  'pinned' : boolean,
  'replies' : number,
  'market' : Principal,
  'moment' : [] | [string],
  'reactions' : Uint32Array,
  'parent' : [] | [bigint],
}
export interface Report {
  'at' : bigint,
  'id' : bigint,
  'post' : bigint,
  'details' : string,
  'reporter' : Principal,
  'reason' : string,
}
export type Result = { 'Ok' : bigint } |
  { 'Err' : string };
export type Result_1 = { 'Ok' : null } |
  { 'Err' : string };
export type Result_2 = { 'Ok' : number } |
  { 'Err' : string };
export type Result_3 = { 'Ok' : Uint32Array } |
  { 'Err' : string };
export type Result_4 = { 'Ok' : string } |
  { 'Err' : string };
export type Result_5 = { 'Ok' : bigint } |
  { 'Err' : string };
export interface Stats { 'posts' : bigint, 'moderators' : Array<Principal> }
/**
 * One day of the bot's activity, for Analytics. Counts only, never who.
 */
export interface TgDay {
  /**
   * Days since 1970.
   */
  'day' : bigint,
  'quick_sells' : number,
  'sends' : number,
  'quick_buys' : number,
  'connects' : number,
  'commands' : number,
  /**
   * What quick trades were worth in USD, when the price was known.
   */
  'quick_usd' : number,
  'new_chats' : number,
  'new_groups' : number,
}
export interface TgInfo {
  'sent_total' : bigint,
  'groups' : bigint,
  /**
   * The bot's username (without @), once it's set up.
   */
  'username' : [] | [string],
  'chats' : bigint,
  /**
   * Whether the caller's account is connected to a Telegram chat.
   */
  'connected' : boolean,
}
export interface TgStats {
  /**
   * All-time sums of the daily rows.
   */
  'all' : TgDay,
  'sent_total' : bigint,
  'groups' : bigint,
  'username' : [] | [string],
  /**
   * The last `days` days, oldest first (days with no activity are left out).
   */
  'days' : Array<TgDay>,
  /**
   * Chats the bot is in now: private chats and groups.
   */
  'chats' : bigint,
  /**
   * Soon accounts connected to a private chat.
   */
  'connected' : bigint,
  /**
   * Different tokens tracked by at least one group.
   */
  'tracked_tokens' : bigint,
}
/**
 * A curve trade, as the factory reported it, kept so people's trades can be followed and shown on
 * their profile (FOMO-style: a buy says more than a post).
 */
export interface Trade {
  'at' : bigint,
  'id' : bigint,
  'buy' : boolean,
  /**
   * What it was worth in USD when it happened, if the price was known.
   */
  'usd' : [] | [number],
  'who' : Principal,
  /**
   * In the base token's smallest units.
   */
  'base' : bigint,
  'base_ledger' : [] | [Principal],
  'tokens' : bigint,
  'market' : Principal,
  'symbol' : string,
}
export interface Voice {
  'who' : Principal,
  'replies' : number,
  'posts' : number,
  'reactions' : number,
}
export interface _SERVICE {
  /**
   * Public, for the Analytics page: how much people talk on Soon over the last `days` (1 to 90).
   * Counts only, never who.
   */
  'activity' : ActorMethod<[number], Activity>,
  /**
   * Post a moment about Soon itself, for figures no canister can work out on its own (all-time USD
   * volume needs ICPSwap's off-chain data). Controllers only; the same text can't go out twice in a
   * day, and at most a few platform moments go out per day. A moderator can hide one posted by mistake.
   */
  'announce' : ActorMethod<[string, string], Result>,
  /**
   * How much someone has posted, since when, and on how many tokens.
   */
  'author_stats' : ActorMethod<[Principal], AuthorStats>,
  /**
   * A person's posts, newest first.
   */
  'by_author' : ActorMethod<
    [Principal, [] | [bigint], number],
    Array<PostView>
  >,
  /**
   * Delete your own post. It stays in the thread as "deleted", without its text.
   */
  'delete_post' : ActorMethod<[bigint], Result_1>,
  /**
   * Top-level posts across every token, newest first. `only`: "posts" (people), "moments" (Soon's,
   * platform moments included) or "soon" (platform moments only).
   */
  'feed' : ActorMethod<[[] | [bigint], number, [] | [string]], Array<PostView>>,
  /**
   * Follow (or unfollow) a person ("person") or a token ("token", its market id).
   */
  'follow' : ActorMethod<[Principal, string, boolean], Result_1>,
  /**
   * How many people follow a person (kind "person") or a token ("token").
   */
  'follower_count' : ActorMethod<[Principal, string], bigint>,
  /**
   * Who and what someone follows.
   */
  'following' : ActorMethod<[Principal], Followed>,
  /**
   * The caller's feed: posts by people they follow, posts (and moments) on tokens they follow, and
   * Soon's platform milestones.
   */
  'following_feed' : ActorMethod<[[] | [bigint], number], Array<PostView>>,
  /**
   * Trades by the people the caller follows, newest first.
   */
  'following_trades' : ActorMethod<[[] | [bigint], number], Array<Trade>>,
  /**
   * Hide (or unhide) a post. Moderators only. A hidden post stays on-chain but is read blank.
   */
  'hide_post' : ActorMethod<[bigint, boolean], Result_1>,
  /**
   * What's catching on: top-level posts and moments from the last two days, scored by reactions and
   * replies and pulled down by age, so a lively post beats a quiet new one but not forever.
   */
  'hot' : ActorMethod<[number], Array<PostView>>,
  'http_request' : ActorMethod<[HttpRequest], HttpResponse>,
  'http_request_update' : ActorMethod<[HttpRequest], HttpResponse>,
  /**
   * Copy a token's existing market chat into its thread, once. Controllers only.
   */
  'import_market' : ActorMethod<[Principal], Result_2>,
  /**
   * Import several tokens' chats in one call (one passphrase for a whole batch). Controllers only.
   */
  'import_markets' : ActorMethod<
    [Array<Principal>],
    Array<[Principal, Result_2]>
  >,
  /**
   * Mark notifications up to `upto` as seen.
   */
  'mark_read' : ActorMethod<[bigint], Result_1>,
  /**
   * The caller's notifications, newest first.
   */
  'notifications' : ActorMethod<[number], Array<Notif>>,
  /**
   * A token's creator pins one of their own posts on its thread as the token's update, and
   * everyone following the token hears about it. `None` unpins.
   */
  'pin' : ActorMethod<[Principal, [] | [bigint]], Result_1>,
  /**
   * The pinned creator updates of some tokens.
   */
  'pinned' : ActorMethod<[Array<Principal>], Array<PostView>>,
  /**
   * The platform milestones already announced (or passed before the first check), per metric.
   */
  'platform_marks' : ActorMethod<[], Array<[string, bigint]>>,
  /**
   * Post on a token's thread, or reply to a post there.
   */
  'post' : ActorMethod<[NewPost], Result>,
  /**
   * Some posts by id (to refresh counts on what's on screen).
   */
  'posts' : ActorMethod<[BigUint64Array], Array<PostView>>,
  /**
   * Toggle one of the four reactions (0 ⏳, 1 🔥, 2 👀, 3 WEN?) on a post. Returns the new counts.
   */
  'react' : ActorMethod<[bigint, number, boolean], Result_3>,
  /**
   * Recent trades across Soon, newest first (the live tape).
   */
  'recent_trades' : ActorMethod<[[] | [bigint], number], Array<Trade>>,
  /**
   * Replies to a post, oldest first.
   */
  'replies' : ActorMethod<[bigint, number], Array<PostView>>,
  /**
   * Report a post. Open to anyone, signed in or not, within a daily budget.
   */
  'report_post' : ActorMethod<[bigint, string, string], Result>,
  /**
   * Reports, newest first. Moderators only.
   */
  'reports' : ActorMethod<[bigint, bigint], Array<Report>>,
  /**
   * Add or remove a moderator. Controllers only.
   */
  'set_moderator' : ActorMethod<[Principal, boolean], Result_1>,
  'stats' : ActorMethod<[], Stats>,
  /**
   * Set up the bot, once, with the token @BotFather gave. The canister checks it with Telegram,
   * learns the bot's username, points Telegram's webhook at itself with a fresh secret, and sets the
   * bot's commands and description. Controllers only. The token is never returned by any call.
   */
  'tg_configure' : ActorMethod<[string], Result_4>,
  /**
   * Switch the bot off: forget the token and secret and stop sending. Chats are kept for when it's
   * set up again. Controllers only.
   */
  'tg_disable' : ActorMethod<[], undefined>,
  /**
   * The bot's username and a few counts, for the site.
   */
  'tg_info' : ActorMethod<[], TgInfo>,
  /**
   * A one-time code that connects the caller's Soon account to the Telegram chat that sends it to
   * the bot (as t.me/<bot>?start=<code>). It works once, within 15 minutes.
   */
  'tg_link' : ActorMethod<[], Result_4>,
  /**
   * The caller's quick-buy subaccount, so anyone can check it holds nothing between buys.
   */
  'tg_quickbuy_account' : ActorMethod<[Principal], Account>,
  /**
   * Send back anything left in the caller's quick-buy subaccount of `ledger` (normally nothing:
   * every buy returns what it doesn't use).
   */
  'tg_return_funds' : ActorMethod<[Principal], Result_5>,
  /**
   * Local tests only: send the Bot API calls somewhere else (a mock). Controllers only.
   */
  'tg_set_api' : ActorMethod<[[] | [string]], undefined>,
  /**
   * Public, for the Analytics page: how much the bot is used. Counts only, never who.
   */
  'tg_stats' : ActorMethod<[number], TgStats>,
  /**
   * Disconnect the caller's account from Telegram.
   */
  'tg_unlink' : ActorMethod<[], Result_1>,
  /**
   * A token's top-level posts, newest first, before post `before` (exclusive) if given.
   */
  'thread' : ActorMethod<[Principal, [] | [bigint], number], Array<PostView>>,
  /**
   * The loudest voices of the last `days` days (at most 30): people ranked by the reactions and
   * replies their posts drew.
   */
  'top_voices' : ActorMethod<[number, number], Array<Voice>>,
  /**
   * A person's curve trades, newest first.
   */
  'trades_of' : ActorMethod<[Principal, [] | [bigint], number], Array<Trade>>,
  /**
   * How many of the caller's notifications are newer than the last one they've seen.
   */
  'unread_count' : ActorMethod<[], number>,
  /**
   * Every post on a token after post `after`, replies included, oldest first: for polling.
   */
  'updates' : ActorMethod<[Principal, bigint, number], Array<PostView>>,
}
export const Init = IDL.Record({ 'factory' : IDL.Principal });
export const Bucket = IDL.Record({
  'posters' : IDL.Nat32,
  'moments' : IDL.Nat32,
  'start' : IDL.Nat64,
  'replies' : IDL.Nat32,
  'posts' : IDL.Nat32,
  'reactions' : IDL.Nat32,
});
export const Activity = IDL.Record({
  'posters' : IDL.Nat32,
  'notifications' : IDL.Nat64,
  'trades' : IDL.Nat64,
  'all_posts' : IDL.Nat64,
  'follows' : IDL.Nat64,
  'bucket_secs' : IDL.Nat64,
  'top_tokens' : IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Nat32)),
  'buckets' : IDL.Vec(Bucket),
});
export const Result = IDL.Variant({ 'Ok' : IDL.Nat64, 'Err' : IDL.Text });
export const AuthorStats = IDL.Record({
  'tokens' : IDL.Nat32,
  'posts' : IDL.Nat64,
  'first_at' : IDL.Opt(IDL.Nat64),
});
export const PostView = IDL.Record({
  'at' : IDL.Nat64,
  'id' : IDL.Nat64,
  'deleted' : IDL.Bool,
  'imported' : IDL.Bool,
  'subject' : IDL.Opt(IDL.Principal),
  'mine' : IDL.Nat8,
  'badges' : IDL.Nat8,
  'hidden' : IDL.Bool,
  'text' : IDL.Text,
  'author' : IDL.Principal,
  'pinned' : IDL.Bool,
  'replies' : IDL.Nat32,
  'market' : IDL.Principal,
  'moment' : IDL.Opt(IDL.Text),
  'reactions' : IDL.Vec(IDL.Nat32),
  'parent' : IDL.Opt(IDL.Nat64),
});
export const Result_1 = IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text });
export const Followed = IDL.Record({
  'people' : IDL.Vec(IDL.Principal),
  'tokens' : IDL.Vec(IDL.Principal),
});
export const Trade = IDL.Record({
  'at' : IDL.Nat64,
  'id' : IDL.Nat64,
  'buy' : IDL.Bool,
  'usd' : IDL.Opt(IDL.Float64),
  'who' : IDL.Principal,
  'base' : IDL.Nat,
  'base_ledger' : IDL.Opt(IDL.Principal),
  'tokens' : IDL.Nat,
  'market' : IDL.Principal,
  'symbol' : IDL.Text,
});
export const HttpRequest = IDL.Record({
  'url' : IDL.Text,
  'method' : IDL.Text,
  'body' : IDL.Vec(IDL.Nat8),
  'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
});
export const HttpResponse = IDL.Record({
  'body' : IDL.Vec(IDL.Nat8),
  'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  'upgrade' : IDL.Opt(IDL.Bool),
  'status_code' : IDL.Nat16,
});
export const Result_2 = IDL.Variant({ 'Ok' : IDL.Nat32, 'Err' : IDL.Text });
export const Notif = IDL.Record({
  'at' : IDL.Nat64,
  'id' : IDL.Nat64,
  'actor' : IDL.Opt(IDL.Principal),
  'kind' : IDL.Text,
  'post' : IDL.Opt(IDL.Nat64),
  'market' : IDL.Opt(IDL.Principal),
});
export const NewPost = IDL.Record({
  'agent' : IDL.Opt(IDL.Bool),
  'text' : IDL.Text,
  'market' : IDL.Principal,
  'parent' : IDL.Opt(IDL.Nat64),
});
export const Result_3 = IDL.Variant({
  'Ok' : IDL.Vec(IDL.Nat32),
  'Err' : IDL.Text,
});
export const Report = IDL.Record({
  'at' : IDL.Nat64,
  'id' : IDL.Nat64,
  'post' : IDL.Nat64,
  'details' : IDL.Text,
  'reporter' : IDL.Principal,
  'reason' : IDL.Text,
});
export const Stats = IDL.Record({
  'posts' : IDL.Nat64,
  'moderators' : IDL.Vec(IDL.Principal),
});
export const Result_4 = IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text });
export const TgInfo = IDL.Record({
  'sent_total' : IDL.Nat64,
  'groups' : IDL.Nat64,
  'username' : IDL.Opt(IDL.Text),
  'chats' : IDL.Nat64,
  'connected' : IDL.Bool,
});
export const Account = IDL.Record({
  'owner' : IDL.Principal,
  'subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
});
export const Result_5 = IDL.Variant({ 'Ok' : IDL.Nat, 'Err' : IDL.Text });
export const TgDay = IDL.Record({
  'day' : IDL.Nat64,
  'quick_sells' : IDL.Nat32,
  'sends' : IDL.Nat32,
  'quick_buys' : IDL.Nat32,
  'connects' : IDL.Nat32,
  'commands' : IDL.Nat32,
  'quick_usd' : IDL.Float64,
  'new_chats' : IDL.Nat32,
  'new_groups' : IDL.Nat32,
});
export const TgStats = IDL.Record({
  'all' : TgDay,
  'sent_total' : IDL.Nat64,
  'groups' : IDL.Nat64,
  'username' : IDL.Opt(IDL.Text),
  'days' : IDL.Vec(TgDay),
  'chats' : IDL.Nat64,
  'connected' : IDL.Nat64,
  'tracked_tokens' : IDL.Nat64,
});
export const Voice = IDL.Record({
  'who' : IDL.Principal,
  'replies' : IDL.Nat32,
  'posts' : IDL.Nat32,
  'reactions' : IDL.Nat32,
});

export const idlService: IDL.ServiceClass = IDL.Service({
  'activity' : IDL.Func([IDL.Nat32], [Activity], ['query']),
  'announce' : IDL.Func([IDL.Text, IDL.Text], [Result], []),
  'author_stats' : IDL.Func([IDL.Principal], [AuthorStats], ['query']),
  'by_author' : IDL.Func(
      [IDL.Principal, IDL.Opt(IDL.Nat64), IDL.Nat32],
      [IDL.Vec(PostView)],
      ['query'],
    ),
  'delete_post' : IDL.Func([IDL.Nat64], [Result_1], []),
  'feed' : IDL.Func(
      [IDL.Opt(IDL.Nat64), IDL.Nat32, IDL.Opt(IDL.Text)],
      [IDL.Vec(PostView)],
      ['query'],
    ),
  'follow' : IDL.Func([IDL.Principal, IDL.Text, IDL.Bool], [Result_1], []),
  'follower_count' : IDL.Func(
      [IDL.Principal, IDL.Text],
      [IDL.Nat64],
      ['query'],
    ),
  'following' : IDL.Func([IDL.Principal], [Followed], ['query']),
  'following_feed' : IDL.Func(
      [IDL.Opt(IDL.Nat64), IDL.Nat32],
      [IDL.Vec(PostView)],
      ['query'],
    ),
  'following_trades' : IDL.Func(
      [IDL.Opt(IDL.Nat64), IDL.Nat32],
      [IDL.Vec(Trade)],
      ['query'],
    ),
  'hide_post' : IDL.Func([IDL.Nat64, IDL.Bool], [Result_1], []),
  'hot' : IDL.Func([IDL.Nat32], [IDL.Vec(PostView)], ['query']),
  'http_request' : IDL.Func([HttpRequest], [HttpResponse], ['query']),
  'http_request_update' : IDL.Func([HttpRequest], [HttpResponse], []),
  'import_market' : IDL.Func([IDL.Principal], [Result_2], []),
  'import_markets' : IDL.Func(
      [IDL.Vec(IDL.Principal)],
      [IDL.Vec(IDL.Tuple(IDL.Principal, Result_2))],
      [],
    ),
  'mark_read' : IDL.Func([IDL.Nat64], [Result_1], []),
  'notifications' : IDL.Func([IDL.Nat32], [IDL.Vec(Notif)], ['query']),
  'pin' : IDL.Func([IDL.Principal, IDL.Opt(IDL.Nat64)], [Result_1], []),
  'pinned' : IDL.Func([IDL.Vec(IDL.Principal)], [IDL.Vec(PostView)], ['query']),
  'platform_marks' : IDL.Func(
      [],
      [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat64))],
      ['query'],
    ),
  'post' : IDL.Func([NewPost], [Result], []),
  'posts' : IDL.Func([IDL.Vec(IDL.Nat64)], [IDL.Vec(PostView)], ['query']),
  'react' : IDL.Func([IDL.Nat64, IDL.Nat8, IDL.Bool], [Result_3], []),
  'recent_trades' : IDL.Func(
      [IDL.Opt(IDL.Nat64), IDL.Nat32],
      [IDL.Vec(Trade)],
      ['query'],
    ),
  'replies' : IDL.Func([IDL.Nat64, IDL.Nat32], [IDL.Vec(PostView)], ['query']),
  'report_post' : IDL.Func([IDL.Nat64, IDL.Text, IDL.Text], [Result], []),
  'reports' : IDL.Func([IDL.Nat64, IDL.Nat64], [IDL.Vec(Report)], ['query']),
  'set_moderator' : IDL.Func([IDL.Principal, IDL.Bool], [Result_1], []),
  'stats' : IDL.Func([], [Stats], ['query']),
  'tg_configure' : IDL.Func([IDL.Text], [Result_4], []),
  'tg_disable' : IDL.Func([], [], []),
  'tg_info' : IDL.Func([], [TgInfo], ['query']),
  'tg_link' : IDL.Func([], [Result_4], []),
  'tg_quickbuy_account' : IDL.Func([IDL.Principal], [Account], ['query']),
  'tg_return_funds' : IDL.Func([IDL.Principal], [Result_5], []),
  'tg_set_api' : IDL.Func([IDL.Opt(IDL.Text)], [], []),
  'tg_stats' : IDL.Func([IDL.Nat32], [TgStats], ['query']),
  'tg_unlink' : IDL.Func([], [Result_1], []),
  'thread' : IDL.Func(
      [IDL.Principal, IDL.Opt(IDL.Nat64), IDL.Nat32],
      [IDL.Vec(PostView)],
      ['query'],
    ),
  'top_voices' : IDL.Func([IDL.Nat32, IDL.Nat32], [IDL.Vec(Voice)], ['query']),
  'trades_of' : IDL.Func(
      [IDL.Principal, IDL.Opt(IDL.Nat64), IDL.Nat32],
      [IDL.Vec(Trade)],
      ['query'],
    ),
  'unread_count' : IDL.Func([], [IDL.Nat32], ['query']),
  'updates' : IDL.Func(
      [IDL.Principal, IDL.Nat64, IDL.Nat32],
      [IDL.Vec(PostView)],
      ['query'],
    ),
});

export const idlInitArgs: IDL.Type[] = [Init];

export const idlFactory: IDL.InterfaceFactory = ({ IDL }) => {
  const Init = IDL.Record({ 'factory' : IDL.Principal });
  const Bucket = IDL.Record({
    'posters' : IDL.Nat32,
    'moments' : IDL.Nat32,
    'start' : IDL.Nat64,
    'replies' : IDL.Nat32,
    'posts' : IDL.Nat32,
    'reactions' : IDL.Nat32,
  });
  const Activity = IDL.Record({
    'posters' : IDL.Nat32,
    'notifications' : IDL.Nat64,
    'trades' : IDL.Nat64,
    'all_posts' : IDL.Nat64,
    'follows' : IDL.Nat64,
    'bucket_secs' : IDL.Nat64,
    'top_tokens' : IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Nat32)),
    'buckets' : IDL.Vec(Bucket),
  });
  const Result = IDL.Variant({ 'Ok' : IDL.Nat64, 'Err' : IDL.Text });
  const AuthorStats = IDL.Record({
    'tokens' : IDL.Nat32,
    'posts' : IDL.Nat64,
    'first_at' : IDL.Opt(IDL.Nat64),
  });
  const PostView = IDL.Record({
    'at' : IDL.Nat64,
    'id' : IDL.Nat64,
    'deleted' : IDL.Bool,
    'imported' : IDL.Bool,
    'subject' : IDL.Opt(IDL.Principal),
    'mine' : IDL.Nat8,
    'badges' : IDL.Nat8,
    'hidden' : IDL.Bool,
    'text' : IDL.Text,
    'author' : IDL.Principal,
    'pinned' : IDL.Bool,
    'replies' : IDL.Nat32,
    'market' : IDL.Principal,
    'moment' : IDL.Opt(IDL.Text),
    'reactions' : IDL.Vec(IDL.Nat32),
    'parent' : IDL.Opt(IDL.Nat64),
  });
  const Result_1 = IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text });
  const Followed = IDL.Record({
    'people' : IDL.Vec(IDL.Principal),
    'tokens' : IDL.Vec(IDL.Principal),
  });
  const Trade = IDL.Record({
    'at' : IDL.Nat64,
    'id' : IDL.Nat64,
    'buy' : IDL.Bool,
    'usd' : IDL.Opt(IDL.Float64),
    'who' : IDL.Principal,
    'base' : IDL.Nat,
    'base_ledger' : IDL.Opt(IDL.Principal),
    'tokens' : IDL.Nat,
    'market' : IDL.Principal,
    'symbol' : IDL.Text,
  });
  const HttpRequest = IDL.Record({
    'url' : IDL.Text,
    'method' : IDL.Text,
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  });
  const HttpResponse = IDL.Record({
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'upgrade' : IDL.Opt(IDL.Bool),
    'status_code' : IDL.Nat16,
  });
  const Result_2 = IDL.Variant({ 'Ok' : IDL.Nat32, 'Err' : IDL.Text });
  const Notif = IDL.Record({
    'at' : IDL.Nat64,
    'id' : IDL.Nat64,
    'actor' : IDL.Opt(IDL.Principal),
    'kind' : IDL.Text,
    'post' : IDL.Opt(IDL.Nat64),
    'market' : IDL.Opt(IDL.Principal),
  });
  const NewPost = IDL.Record({
    'agent' : IDL.Opt(IDL.Bool),
    'text' : IDL.Text,
    'market' : IDL.Principal,
    'parent' : IDL.Opt(IDL.Nat64),
  });
  const Result_3 = IDL.Variant({ 'Ok' : IDL.Vec(IDL.Nat32), 'Err' : IDL.Text });
  const Report = IDL.Record({
    'at' : IDL.Nat64,
    'id' : IDL.Nat64,
    'post' : IDL.Nat64,
    'details' : IDL.Text,
    'reporter' : IDL.Principal,
    'reason' : IDL.Text,
  });
  const Stats = IDL.Record({
    'posts' : IDL.Nat64,
    'moderators' : IDL.Vec(IDL.Principal),
  });
  const Result_4 = IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text });
  const TgInfo = IDL.Record({
    'sent_total' : IDL.Nat64,
    'groups' : IDL.Nat64,
    'username' : IDL.Opt(IDL.Text),
    'chats' : IDL.Nat64,
    'connected' : IDL.Bool,
  });
  const Account = IDL.Record({
    'owner' : IDL.Principal,
    'subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
  });
  const Result_5 = IDL.Variant({ 'Ok' : IDL.Nat, 'Err' : IDL.Text });
  const TgDay = IDL.Record({
    'day' : IDL.Nat64,
    'quick_sells' : IDL.Nat32,
    'sends' : IDL.Nat32,
    'quick_buys' : IDL.Nat32,
    'connects' : IDL.Nat32,
    'commands' : IDL.Nat32,
    'quick_usd' : IDL.Float64,
    'new_chats' : IDL.Nat32,
    'new_groups' : IDL.Nat32,
  });
  const TgStats = IDL.Record({
    'all' : TgDay,
    'sent_total' : IDL.Nat64,
    'groups' : IDL.Nat64,
    'username' : IDL.Opt(IDL.Text),
    'days' : IDL.Vec(TgDay),
    'chats' : IDL.Nat64,
    'connected' : IDL.Nat64,
    'tracked_tokens' : IDL.Nat64,
  });
  const Voice = IDL.Record({
    'who' : IDL.Principal,
    'replies' : IDL.Nat32,
    'posts' : IDL.Nat32,
    'reactions' : IDL.Nat32,
  });

  return IDL.Service({
    'activity' : IDL.Func([IDL.Nat32], [Activity], ['query']),
    'announce' : IDL.Func([IDL.Text, IDL.Text], [Result], []),
    'author_stats' : IDL.Func([IDL.Principal], [AuthorStats], ['query']),
    'by_author' : IDL.Func(
        [IDL.Principal, IDL.Opt(IDL.Nat64), IDL.Nat32],
        [IDL.Vec(PostView)],
        ['query'],
      ),
    'delete_post' : IDL.Func([IDL.Nat64], [Result_1], []),
    'feed' : IDL.Func(
        [IDL.Opt(IDL.Nat64), IDL.Nat32, IDL.Opt(IDL.Text)],
        [IDL.Vec(PostView)],
        ['query'],
      ),
    'follow' : IDL.Func([IDL.Principal, IDL.Text, IDL.Bool], [Result_1], []),
    'follower_count' : IDL.Func(
        [IDL.Principal, IDL.Text],
        [IDL.Nat64],
        ['query'],
      ),
    'following' : IDL.Func([IDL.Principal], [Followed], ['query']),
    'following_feed' : IDL.Func(
        [IDL.Opt(IDL.Nat64), IDL.Nat32],
        [IDL.Vec(PostView)],
        ['query'],
      ),
    'following_trades' : IDL.Func(
        [IDL.Opt(IDL.Nat64), IDL.Nat32],
        [IDL.Vec(Trade)],
        ['query'],
      ),
    'hide_post' : IDL.Func([IDL.Nat64, IDL.Bool], [Result_1], []),
    'hot' : IDL.Func([IDL.Nat32], [IDL.Vec(PostView)], ['query']),
    'http_request' : IDL.Func([HttpRequest], [HttpResponse], ['query']),
    'http_request_update' : IDL.Func([HttpRequest], [HttpResponse], []),
    'import_market' : IDL.Func([IDL.Principal], [Result_2], []),
    'import_markets' : IDL.Func(
        [IDL.Vec(IDL.Principal)],
        [IDL.Vec(IDL.Tuple(IDL.Principal, Result_2))],
        [],
      ),
    'mark_read' : IDL.Func([IDL.Nat64], [Result_1], []),
    'notifications' : IDL.Func([IDL.Nat32], [IDL.Vec(Notif)], ['query']),
    'pin' : IDL.Func([IDL.Principal, IDL.Opt(IDL.Nat64)], [Result_1], []),
    'pinned' : IDL.Func(
        [IDL.Vec(IDL.Principal)],
        [IDL.Vec(PostView)],
        ['query'],
      ),
    'platform_marks' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat64))],
        ['query'],
      ),
    'post' : IDL.Func([NewPost], [Result], []),
    'posts' : IDL.Func([IDL.Vec(IDL.Nat64)], [IDL.Vec(PostView)], ['query']),
    'react' : IDL.Func([IDL.Nat64, IDL.Nat8, IDL.Bool], [Result_3], []),
    'recent_trades' : IDL.Func(
        [IDL.Opt(IDL.Nat64), IDL.Nat32],
        [IDL.Vec(Trade)],
        ['query'],
      ),
    'replies' : IDL.Func(
        [IDL.Nat64, IDL.Nat32],
        [IDL.Vec(PostView)],
        ['query'],
      ),
    'report_post' : IDL.Func([IDL.Nat64, IDL.Text, IDL.Text], [Result], []),
    'reports' : IDL.Func([IDL.Nat64, IDL.Nat64], [IDL.Vec(Report)], ['query']),
    'set_moderator' : IDL.Func([IDL.Principal, IDL.Bool], [Result_1], []),
    'stats' : IDL.Func([], [Stats], ['query']),
    'tg_configure' : IDL.Func([IDL.Text], [Result_4], []),
    'tg_disable' : IDL.Func([], [], []),
    'tg_info' : IDL.Func([], [TgInfo], ['query']),
    'tg_link' : IDL.Func([], [Result_4], []),
    'tg_quickbuy_account' : IDL.Func([IDL.Principal], [Account], ['query']),
    'tg_return_funds' : IDL.Func([IDL.Principal], [Result_5], []),
    'tg_set_api' : IDL.Func([IDL.Opt(IDL.Text)], [], []),
    'tg_stats' : IDL.Func([IDL.Nat32], [TgStats], ['query']),
    'tg_unlink' : IDL.Func([], [Result_1], []),
    'thread' : IDL.Func(
        [IDL.Principal, IDL.Opt(IDL.Nat64), IDL.Nat32],
        [IDL.Vec(PostView)],
        ['query'],
      ),
    'top_voices' : IDL.Func(
        [IDL.Nat32, IDL.Nat32],
        [IDL.Vec(Voice)],
        ['query'],
      ),
    'trades_of' : IDL.Func(
        [IDL.Principal, IDL.Opt(IDL.Nat64), IDL.Nat32],
        [IDL.Vec(Trade)],
        ['query'],
      ),
    'unread_count' : IDL.Func([], [IDL.Nat32], ['query']),
    'updates' : IDL.Func(
        [IDL.Principal, IDL.Nat64, IDL.Nat32],
        [IDL.Vec(PostView)],
        ['query'],
      ),
  });
};

export const init: (args: { IDL: typeof IDL }) => IDL.Type[] = ({ IDL }) => {
  const Init = IDL.Record({ 'factory' : IDL.Principal });

  return [Init];
};
